import ProductDatabaseCBDA from './ProductDatabaseCBDA';
import ProductDatabaseExample from './ProductDatabaseExample';
import IProductDatabase from './IProductDatabase';
import { wlPath } from './Whitelabel';

export const db: IProductDatabase = ( () => {
  if ( 'cbda' === wlPath ) {
    return new ProductDatabaseCBDA(wlPath);
  }
  else {
    return new ProductDatabaseExample(wlPath);
  }
} )();
